import {
  pickSummaryColumns,
  summaryCardsGetter,
} from '@fingo/lib/features/operations-status';

export const DETAIL_SUMMARY_TABLE_COLUMNS = pickSummaryColumns([
  'receiver',
  'amount',
  'monthlyRate',
  'operationDays',
  'dateToPay',
]);

export const getCurrentSummaryCards = summaryCardsGetter(['current-invoices', 'total-owed']);

export const getHistoricSummaryCards = summaryCardsGetter(['historic-invoices']);
